// extracted by mini-css-extract-plugin
export var carouselBackdrop = "styles-module--carousel-backdrop--1fbHv";
export var carouselWrapper = "styles-module--carousel-wrapper--274nh";
export var carouselBackground = "styles-module--carousel-background--1eya_";
export var carouselSlide = "styles-module--carousel-slide--3SW_N";
export var carouselDots = "styles-module--carousel-dots--1r-Ic";
export var carouselCard = "styles-module--carousel-card--36Ufp";